import { QueryParameter, AppContext } from "Core";
import { ServiceProvider } from "Service";
import { IDisposable } from "Core/Interfaces";
import CancellationToken from "cancellationtoken";

export class Page implements IDisposable {
    public static headerView = require("../Layouts/Header.html").default;

    public static current: Page;

    public currentTextBlockCategory: string;
    public pageToken: string;

    protected headerView: kendo.View;

    public viewModel: kendo.data.ObservableObject;

    protected isDestroyed = false;

    constructor(protected serviceProvider: ServiceProvider) {
        Page.current = this;
        this.viewModel = kendo.observable({
            TextBlock: {},
            getTextBlock: (textBlockName: string) => {
                this.viewModel.get("TextBlock");
                return this.serviceProvider.TextBlock.get(textBlockName, this.currentTextBlockCategory);
            },
        });
        const usedTextBlocks = ["pageTitle", "pageDescription", "pageContent"];

        for (const textblock of usedTextBlocks) {
            (<any>this.viewModel)[`getTextBlock${textblock}`] = () => {
                this.viewModel.get("TextBlock");
                return this.serviceProvider.TextBlock.get(textblock, this.currentTextBlockCategory);
            };
        }
    }

    public canNavigate(): boolean {
        return true;
    }

    /**
     * Initialize CoreContext.
     * @param pageToken Unique token which is processed with all requests
     * @param textBlockCategory Name of the textBlockCategory.
     * @hidden
     */
    public async initialize(textBlockCategory: string): Promise<void> {
        textBlockCategory = QueryParameter.get("tbm")?.toLowerCase() || textBlockCategory.toLowerCase();
        let textBlockCategories = [textBlockCategory];
        this.serviceProvider.TextBlock.load(AppContext.current.environment.LanguageCode, textBlockCategories.toString()).then(
            (textblocks) => {
                document.title =
                    AppContext.current.environment.BrowserTitle +
                    " " +
                    this.serviceProvider.TextBlock.getChecked(textblocks[textBlockCategory], "pageTitle", textBlockCategory, true);
                this.viewModel.set("TextBlock", textblocks);
            }
        );
        AppContext.current.currentTextBlockCategory = this.currentTextBlockCategory = textBlockCategory;

        let pageTokenResult = await this.serviceProvider.PageToken.get();
        this.pageToken = pageTokenResult.PageToken;
        /*this.initialTextBlockCategory = */

        this.serviceProvider.PageToken.startPolling(pageTokenResult.PageToken, 10);
        $(window).on("beforeunload", () => this.onWindowUnload());
    }

    async render(layout: kendo.Layout, cancellationToken: CancellationToken): Promise<void> {
        this.headerView = new kendo.View(Page.headerView, { model: this.viewModel });
        layout.showIn(".dms-content-header", this.headerView);
    }

    /**
     * Calculate the available height for the content area.
     * @hidden
     */
    public getAvailableHeight(): number {
        let windowHeight = $(window).height();
        return windowHeight;
    }

    public resize(): void {}

    /**
     * @hidden
     */
    public allowPageTokenRelease = true;

    private onWindowUnload() {
        try {
            if (this.allowPageTokenRelease) {
                this.serviceProvider.PageToken.sendRelease();
            }
        } catch (e) {}
    }

    dispose(): void {
        if (this.headerView) {
            this.headerView.destroy();
        }
        this.onWindowUnload();
    }
}
